export default "__VITE_ASSET__I2wOiM1J__"